import { ITimeObject, timeResolve } from '@/common/js/date';
import VueI18n from 'vue-i18n';

export const getIANATimeZone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone;

export type TimeFormat = 'normal' | '12';

export const formatTime = (
    timeStamp: number,
    translate:  ( key: VueI18n.Path, values?: VueI18n.Values ) => VueI18n.TranslateResult,
    withHour?: TimeFormat
): string => {

    const {
        year,
        month,
        dateOfMonth,
        hour,
        hourOf12Decimal,
        minute,
        noon
    }: ITimeObject = timeResolve( timeStamp );

    const dateString = translate( 'date_format.default', {
        year,
        month,
        day: dateOfMonth
    }) as string;

    if ( !withHour ) {

        return dateString;

    } else if ( withHour === 'normal' ) {

        const time = `${hour}:${minute}`;

        return `${dateString} ${time}`;

    } else {

        const time = `${hourOf12Decimal}:${minute} ${noon}`;

        return `${dateString} ${time}`;

    }

};
